export default __webpack_public_path__ + "static/media/marker.d47c0764.svg";